/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/7/17 16:18
 * @des 时间格式化
 */

import {t} from '@/base/i18n'

// 60000 1分钟
// 3600000 1小时
// 86400000 24小时
// 对传入时间进行时间转换
export function formatTime (timeValue) {
  var timeNew = Date.parse(new Date()) // 当前时间
  var timeDiffer = timeNew - timeValue // 与当前时间误差
  var returnTime = ''

  if (timeDiffer < 86400000 && isYestday(timeValue) === false) { // 今日
    returnTime = formatDateTime(timeValue).substr(11, 5)
  } else if (timeDiffer > 3600000 && isYestday(timeValue) === true) { // 昨天
    returnTime = t('common_common.timeUtil.yesterday', {time: formatDateTime(timeValue).substr(11, 5)})
  } else if (timeDiffer > 86400000 && isYestday(timeValue) === false && isYear(timeValue) === true) { // 今年
    returnTime = formatDateTime(timeValue).substr(5, 11)
  } else if (timeDiffer > 86400000 && isYestday(timeValue) === false && isYear(timeValue) === false) { // 不属于今年
    returnTime = formatDateTime(timeValue).substr(0, 10)
  }

  return returnTime
}

// 时间戳转换日期 (yyyy-MM-dd HH:mm:ss)
export function formatDateTime (timeValue) {
  var date = new Date(timeValue)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  var d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  var h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  var minute = date.getMinutes()
  var second = date.getSeconds()
  minute = minute < 10 ? ('0' + minute) : minute
  second = second < 10 ? ('0' + second) : second
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
}

export function formatDateTime2 (ts, format) {
  if (!format) {
    format = 'yyyy-MM-dd hh:mm:ss'
  }
  let date = new Date(ts)
  let o = {
    'M+': date.getMonth() + 1, // month
    'd+': date.getDate(), // day
    'h+': date.getHours(), // hour
    'm+': date.getMinutes(), // minute
    's+': date.getSeconds(), // second
    'S': date.getMilliseconds() // millisecond
  }

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }

  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }

  return format
}

// 判断传入日期是否为昨天
function isYestday (timeValue) {
  var date = (new Date()) // 当前时间
  var today = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() // 今天凌晨
  var yestday = new Date(today - 24 * 3600 * 1000).getTime()
  return timeValue < today && yestday <= timeValue
}

// 判断传入日期是否属于今年
export function isYear (timeValue) {
  var takeNewYear = formatDateTime(new Date()).substr(0, 4) // 当前时间的年份
  var takeTimeValue = formatDateTime(timeValue).substr(0, 4) // 传入时间的年份
  return takeTimeValue == takeNewYear
}

/**
 * 获取显示一个时间段的字符串
 * @param startDateString 开始时间
 * @param endDateString 结束时间
 * @returns {*}
 */
export function getDateTimeIntervalString (startDateString, endDateString) {
  let startString = '_:_'
  let endString = '_:_'
  if (startDateString && endDateString) {
    let startTs = new Date(startDateString).getTime()
    let endTs = new Date(endDateString).getTime()
    let dateTimeFormat = 'yyyy-MM-dd hh:mm'
    if (isYear(startTs)) { // 如果是今年则不显示年份
      dateTimeFormat = 'MM-dd hh:mm'
    }
    let dateTimeFormat2 = dateTimeFormat
    if (endTs >= startTs && isTheSameDay(startTs, endTs)) { // 如果两个时间是同一天，则后面的时间不必显示日期
      dateTimeFormat2 = 'hh:mm'
    }
    startString = formatDateTime2(startTs, dateTimeFormat)
    endString = formatDateTime2(endTs, dateTimeFormat2)
  }
  return `${startString}-${endString}`
}

/**
 * 判断两个时间段是否有重叠
 * @param startTs1 时间段1开始（单位毫秒）
 * @param endTs1 时间段1结束（单位毫秒）
 * @param startTs2 时间段2开始（单位毫秒）
 * @param endTs2 时间段2结束（单位毫秒）
 * @returns {boolean}
 */
export function isOverlapDateTime (startTs1, endTs1, startTs2, endTs2) {
  if (startTs1 >= startTs2 && startTs1 <= endTs2) {
    return true
  } else if (endTs1 >= startTs2 && endTs1 <= endTs2) {
    return true
  } else if (startTs1 <= startTs2 && endTs1 >= endTs2) {
    return true
  } else {
    return false
  }
}

/**
 * 将时间(毫秒级别)转成文字描述
 * @param msTime
 * @param showSeconds 是否显示秒级别描述
 */
export function durationTimeToText (msTime, showSeconds = false) {
  let day = Math.floor(msTime / (24 * 60 * 60 * 1000))
  let hour = Math.floor((msTime - day * 24 * 60 * 60 * 1000) / (60 * 60 * 1000))
  let minute = Math.floor((msTime - day * 24 * 60 * 60 * 1000 - hour * 60 * 60 * 1000) / (60 * 1000))
  let dayText = (day > 0) ? (day + t('common_common.timeUtil.day')) : ''
  let hourText = (hour > 0) ? (hour + t('common_common.timeUtil.hour')) : ''
  let minuteText = (minute > 0) ? (minute + t('common_common.timeUtil.minute')) : ''
  let secondsText = ''
  if (showSeconds) {
    let seconds = Math.floor(msTime / 1000) % 60
    secondsText = (seconds > 0) ? seconds + t('common_common.timeUtil.seconds') : ''
  }
  return dayText + hourText + minuteText + secondsText
}

/**
 * 格式化时间(不是日期)
 * @param duration(毫秒) 返回形如：duration = 12000(两分钟) -> 02:00
 */
export function formatDuration (duration) {
  let hour = Math.floor(duration / (60 * 60 * 1000))
  let minute = Math.floor((duration % (60 * 60 * 1000)) / (60 * 1000))
  let second = Math.floor((duration % (60 * 1000)) / 1000)

  let hourStr = hour < 10 ? '0' + hour : '' + hour
  let minuteStr = minute < 10 ? '0' + minute : '' + minute
  let secondStr = second < 10 ? '0' + second : '' + second

  return (hourStr === '00' ? '' : (hourStr + ':')) + minuteStr + ':' + secondStr
}

/**
 * 判断时间戳时间是否是今天的时间
 * @param ts
 * @returns {boolean}
 */
export function isToday (ts) {
  let currentTs = new Date().getTime()
  return isTheSameDay(currentTs, ts)
}

/**
 * 判断两个时间戳是否是同一天
 * @param ts1
 * @param ts2
 * @returns {boolean}
 */
export function isTheSameDay (ts1, ts2) {
  let format = 'yyyy-MM-dd'
  return formatDateTime2(ts1, format) === formatDateTime2(ts2, format)
}

/**
 * 获取时区表示,能获取时区使用时区否则使用GMT(GMT夏令时问题需要服务器端负责处理)
 */
export function getTimeZoneGmt () {
  let timezone = null
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (e) {
  }
  if (!timezone) {//兼容性处理
    let timezoneOffset = 0 - new Date().getTimezoneOffset()
    let gmt_str = 'GMT+'
    if (timezoneOffset < 0) {
      gmt_str = 'GMT-'
      timezoneOffset = -timezoneOffset
    }
    gmt_str = gmt_str + formatDuration(timezoneOffset * 60 * 1000).slice(0, 5)
    timezone = gmt_str
  }
  return timezone
}


/**
 * 获取时间的时间戳
 * @param time:'2015-03-05 17:59:00.0';
 * @returns {number} 时间戳 单位ms
 */
export function getTimeTs (time) {
  let time2 = time.replace(/-/g, '/') // 必须把日期'-'转为'/'
  let timestamp = new Date(time2).getTime()
  return timestamp
}

/**
 * 获取当前时间戳
 * @returns {number} 时间戳 单位ms
 */
export function getNowTs () {
  let timestamp = new Date().getTime()
  return timestamp
}




// WEBPACK FOOTER //
// ./src/base/util/timeutil.js